import TECH_SHEET_TYPES from "redux/types/techSheet";

const INITIAL_STATE = {
  id: null,
  name: null,
  type: null,
  htmlStructure: null,
  createdBy: null,
  isDefault: null,
  updatedBy: null,
  createdAt: null,
  updatedAt: null,
};

export default function techSheetReducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case TECH_SHEET_TYPES.GET_TECH_SHEET:
      return { ...state, ...action.techSheet };
    case TECH_SHEET_TYPES.CLEAR:
      return { ...state, ...INITIAL_STATE };
    case TECH_SHEET_TYPES.SET_HTML_STRUCTURE:
      return { ...state, htmlStructure: action.payload };
    default:
      return state;
  }
}
